// NOTE: client-side-logger will be used later as port hooks from checkokut-mfe into fulfillment
const useLog = () => {
  const log = () => log;
  log.debug = () => log;
  log.error = () => log;
  return log;
};

export const clientSideLogger = {
  disableAllLoggers() { },
};

export default useLog;
